/* @ngInject */
const myRailwayEditForm = () => {
  return {
    restrict: 'E',
    scope: {
      myRailway: '=',
      enableTitle: '=?',
      enableBack: '=?',
    },
    template: require('./myRailwayEditForm.html'),

    /* @ngInject */
    controller: (
      $scope,
      $$railway
    ) => {
      $scope.update = (_railway) => {
        $$railway.ask.update(_railway, true)
      }
    },
    link: {
      pre: (scope, element, attrs) => {

      },
      post: (scope, element, attrs, ctrl) => {

      },
    },
  }
}

export default myRailwayEditForm



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/rails/railway/directives/forms/myRailwayEditForm.js